import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=35a9c621&scoped=true&"
import script from "./TicketCard.vue?vue&type=script&lang=js&"
export * from "./TicketCard.vue?vue&type=script&lang=js&"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=35a9c621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9c621",
  null
  
)

export default component.exports